module.exports = __webpack_public_path__ + "media/famfary.883d6985.mp3";